import AmexHowItWorks from './AmexHowItWorks';

export default AmexHowItWorks;
